import { HtmlText } from "pymble-ui/components";
import StatCards from "../groups/StatCards";

import "./InformationTab.css";

interface InformationTabProps {
  description?: string;
  counts: { members: number; notices: number; events: number };
  onNavigateTab: (tab: string) => void;
}

/**
 * Information tab - group stats and description. Page authoring moved to
 * My Pymble (see docs/architecture/group-pages in my-pymble-portal).
 */
const InformationTab: React.FC<InformationTabProps> = ({
  description,
  counts,
  onNavigateTab,
}) => {
  return (
    <div className="information-tab">
      <StatCards
        members={counts.members}
        notices={counts.notices}
        events={counts.events}
        onNavigate={onNavigateTab}
      />

      {description && (
        <div className="group-description">
          <HtmlText htmltext={description} />
        </div>
      )}
    </div>
  );
};

export default InformationTab;
